import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { resources, supportedLanguages } from '#app/i18n/translations'

// Detection order mirrors marketplace (fixrate-marketplace/src/app/services/i18n.ts):
// URL ?lng → cookie → localStorage/sessionStorage → browser, falling back to nb.
//
// The user's selected language lives in the `i18next` cookie. We scope that
// cookie to the parent domain (.fixrate.no / .fixrate.dev) so a choice made
// in marketplace carries into the login + consent screens, and vice versa.
// localStorage is per-origin and can't be shared across subdomains, so the
// cookie is the cross-app carrier — we therefore cache to it explicitly.
function cookieParentDomain(): string | undefined {
    const host = window.location.hostname
    if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return undefined
    const parts = host.split('.')
    if (parts.length <= 2) return undefined
    // idp.fixrate.no → .fixrate.no ; idp.fixrate.dev → .fixrate.dev
    return '.' + parts.slice(-2).join('.')
}

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'nb',
        supportedLngs: Object.keys(supportedLanguages),
        nonExplicitSupportedLngs: true,
        ns: ['translations'],
        defaultNS: 'translations',
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator'],
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            lookupSessionStorage: 'i18nextLng',
            caches: ['cookie', 'localStorage'],
            cookieDomain: cookieParentDomain(),
            cookieMinutes: 60 * 24 * 365,
        },
        interpolation: { escapeValue: false },
    })

export default i18n
